module.exports = __webpack_public_path__ + "assets/img/user_icon_hover.30342482.png";